import { useState } from "react";

// Per-browser switch for desktop alerts, toast and tab-title count.
// Stored only when off, so a missing key means on. Never touches the
// browser's own notification permission.
export const ALERTS_OFF_KEY = "browser_alerts_off";

export const alertsOn = () => {
  try {
    return localStorage.getItem(ALERTS_OFF_KEY) !== "1";
  } catch {
    return true;
  }
};

const isBlocked = () =>
  typeof Notification !== "undefined" && Notification.permission === "denied";

const BrowserAlertsSetting = () => {
  const [on, setOn] = useState(alertsOn);

  const toggle = () => {
    const next = !on;
    try {
      if (next) localStorage.removeItem(ALERTS_OFF_KEY);
      else localStorage.setItem(ALERTS_OFF_KEY, "1");
    } catch {
      // Private mode: the choice holds for this visit only.
    }
    setOn(next);
  };

  return (
    <div className="mt-10 bg-white shadow-sm rounded-lg px-4 py-5 sm:px-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Browser alerts</h2>
          <p className="text-sm text-gray-600">
            Desktop alerts, pop-ups and the unread count in the tab title. This setting applies to this browser only.
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={on}
          aria-label="Browser alerts"
          onClick={toggle}
          className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition ${on ? "bg-teal-700" : "bg-gray-300"}`}
        >
          <span
            className={`inline-block h-5 w-5 rounded-full bg-white transition ${on ? "translate-x-5" : "translate-x-0.5"}`}
          />
        </button>
      </div>
      {isBlocked() && (
        <p className="mt-3 text-sm text-gray-700">
          Notifications are blocked in this browser. To unblock them, click the lock icon next to the web address,
          set Notifications to Allow, then reload the page.
        </p>
      )}
    </div>
  );
};

export default BrowserAlertsSetting;
